
import React from 'react';

export const MissionSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Our Mission & Vision
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We are committed to making travel dreams come true while creating lasting memories for every generation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Mission */}
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-compass-3-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-gray-700 leading-relaxed">
              To provide exceptional, personalized travel experiences that exceed expectations while fostering meaningful connections between people, cultures, and destinations. We strive to make every journey seamless, memorable, and transformative for travelers of all ages.
            </p>
          </div>

          {/* Vision */}
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-earth-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
            <p className="text-gray-700 leading-relaxed">
              To be the world's most trusted multi-generational travel partner, inspiring families and individuals to explore the world together while creating bonds that last a lifetime. We envision a world where travel bridges cultures and generations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
